import { ResourceType } from '../../shared/resource-type';

export const SUBMISSION_DEFINITIONS_TYPE = new ResourceType('submissiondefinitions');

export const SUBMISSION_DEFINITION_TYPE = new ResourceType('submissiondefinition');

export const SUBMISSION_FORM_TYPE = new ResourceType('submissionform');

export const SUBMISSION_FORMS_TYPE = new ResourceType('submissionforms');

export const SUBMISSION_SECTIONS_TYPE = new ResourceType('submissionsections');

export const SUBMISSION_SECTION_TYPE = new ResourceType('submissionsection');

export const SUBMISSION_UPLOADS_TYPE = new ResourceType('submissionuploads');

export const SUBMISSION_UPLOAD_TYPE = new ResourceType('submissionupload');
